import { User } from '@auth0/auth0-spa-js'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import Menu from '../Menu'

import { styled } from '@mui/material/styles'
import ProfilePictureBlock from '../ProfilePictureBlock'
import { CustomerIcon, LogoutIcon } from '../icons'
import { OrganizationsIcon } from '../icons/organizations'

const MenuItem = styled('div')(() => {
  return {
    display: 'flex',
    span: {
      paddingLeft: '10px',
    },
  }
})
interface Props {
  user?: User
  logout: () => void
  isSettingsAllowed: boolean
}

const ProfileMenu: React.FC<React.PropsWithChildren<Props>> = ({
  user,
  logout,
  isSettingsAllowed,
}: Props) => {
  const navigate = useNavigate()

  const goToProfile = () => {
    void navigate('/profile')
  }
  const goToOrganizations = () => {
    void navigate('/organization-settings')
  }
  const handleLogout = () => {
    logout()
  }
  return (
    <Menu
      right="0"
      top="101%"
      toggler={<ProfilePictureBlock user={user} size="40px" />}
      items={[
        {
          content: (
            <MenuItem>
              <CustomerIcon />
              <span>Profile</span>
            </MenuItem>
          ),
          action: goToProfile,
        },
        isSettingsAllowed
          ? {
              content: (
                <MenuItem>
                  <OrganizationsIcon />
                  <span>Organizations</span>
                </MenuItem>
              ),
              action: goToOrganizations,
            }
          : null,
        {
          content: (
            <MenuItem>
              <LogoutIcon />
              <span>Log Out</span>
            </MenuItem>
          ),
          action: handleLogout,
        },
      ]}
    />
  )
}

export default ProfileMenu
